module.exports = __webpack_public_path__ + "img/img-card-2.44ce79c6.svg";